import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { LoginStylingViewModel } from './login-styling-view-model.generated';

@Injectable({
    providedIn: 'root'
})
export class GetLoginStylingService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public getLoginStyling(options?: ApiProxyOptions): Observable<LoginStylingViewModel> {
        return this._concurrentRequestHandlingService.callApi<LoginStylingViewModel>(
            "GetLoginStylingService_getLoginStyling",
            {
                url: '/PortalConfig/GetLoginStyling/GetLoginStyling',
                body: {},
                sendCredentials: false
            }, options
        );
    }
}
